import { I18n } from '@aws-amplify/core'

import arWords from './ar'
import esWords from './es'
import ptWords from './pt'

const dict = Object.assign({}, arWords, esWords, ptWords)
I18n.putVocabularies(dict)
